import { toast } from 'react-hot-toast';

/**
 * Acceso a `localStorage` para los datos de sesión.
 *
 * Extraído de `useAuthStore.js` (Ola 10, punto 10-20).
 *
 * Va envuelto en `try` porque `localStorage` lanza en más casos de los que
 * parece: navegación privada de Safari, cuota agotada, o el usuario bloqueando
 * el almacenamiento del sitio. Antes, cualquiera de esos casos tumbaba la
 * aplicación en el arranque.
 */

export const CLAVES = {
  usuario: 'user',
  token: 'gestas_access_token',
};

const HAY_NAVEGADOR = typeof window !== 'undefined';

/**
 * Registro de depuración, solo con `VITE_DEBUG_HOSTS=true`.
 *
 * Defecto corregido en la Ola 10: varias trazas de este store escribían en
 * consola SIN esta guarda, y volcaban el correo, el identificador, el rol y la
 * respuesta completa del perfil. En producción eso queda a la vista de
 * cualquiera que abra las herramientas del navegador.
 */
export const registrar = (mensaje, datos) => {
  if (import.meta.env.VITE_DEBUG_HOSTS !== 'true') return;
  if (datos === undefined) console.log(mensaje);
  else console.log(mensaje, datos);
};

export const leer = (clave) => {
  if (!HAY_NAVEGADOR) return null;
  try {
    return localStorage.getItem(clave);
  } catch {
    return null;
  }
};

export const guardar = (clave, valor) => {
  if (!HAY_NAVEGADOR) return;
  try {
    localStorage.setItem(clave, valor);
  } catch {
    // Con la cuota agotada la sesión no sobrevive a una recarga, así que el
    // usuario debe enterarse.
    toast.error('No se pudieron guardar los datos de sesión en este navegador.');
  }
};

export const borrar = (clave) => {
  if (!HAY_NAVEGADOR) return;
  try {
    localStorage.removeItem(clave);
  } catch {
    // Nada que hacer: si no se puede borrar, tampoco se pudo guardar.
  }
};

/** Usuario guardado. Si el JSON está corrupto, lo limpia y devuelve null. */
export const usuarioGuardado = () => {
  const contenido = leer(CLAVES.usuario);
  if (!contenido) return null;

  try {
    return JSON.parse(contenido);
  } catch {
    borrar(CLAVES.usuario);
    return null;
  }
};

export const haySesion = () => Boolean(leer(CLAVES.token));

/** Borra los dos elementos de sesión a la vez. */
export const limpiarSesion = () => {
  borrar(CLAVES.usuario);
  borrar(CLAVES.token);
};
